export default __webpack_public_path__ + "static/media/slide1.e61534b4.jpg";